import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useSearchParams, Link } from "react-router-dom";
import Post_content from '../../community/content/Blog_posts.jsx';
import { Cookies } from '../../index.js';

const MovieList = () => {
    const { slug_2 } = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const currentPage = Number(searchParams.get("page")) || 1;
    const [moviesData, setMovieData] = useState(null);
    const myCookieValue = Cookies.get('apikey');
    // Hàm chuyển hướng
    function switch_router(link) {
        navigate(link);
    }

    // Gọi API với slug_2 và page
    const laydulieu = (page = 1) => {
        axios
            .get("https://hust.media/giai-tri/visual/category_test.php", {
                params: { slug_2: slug_2, page: page },
            })
            .then((response) => {
                setMovieData(response.data);
            })
            .catch((error) => console.log(error));
    };

    // Reset dữ liệu và gọi API khi slug_2 hoặc currentPage thay đổi
    useEffect(() => {
        setMovieData(null);
        laydulieu(currentPage);
    }, [slug_2, currentPage]);

    // Xử lý chuyển trang bằng hàm switch_router
    const handlePageChange = (page) => {
        if (page === "...") return;
        if (page < 1 || (moviesData && page > moviesData.page.last_page)) return;
        switch_router(
            `/reactapp/visual/category_test/${slug_2}?webappmode=showadview&page=${page}`
        );
    };

    // Render số trang theo logic:
    // - Nếu lastPage ≤ 7: hiển thị tất cả.
    // - Nếu currentPage < 4: hiển thị [1,2,3,4, "...", lastPage-1, lastPage]
    // - Nếu currentPage === 4: hiển thị [1,2,3,4,5, "...", lastPage-1, lastPage]
    // - Nếu currentPage > lastPage - 4: hiển thị [1,2, "...", lastPage-4, lastPage-3, lastPage-2, lastPage-1, lastPage]
    // - Các trường hợp còn lại: hiển thị [1,2, "...", currentPage-1, currentPage, currentPage+1, "...", lastPage-1, lastPage]
    const renderPaginationNumbers = () => {
        const lastPage = moviesData.page.last_page;
        let pages = [];
        if (lastPage <= 7) {
            for (let i = 1; i <= lastPage; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage < 4) {
                pages = [1, 2, 3, 4, "...", lastPage - 1, lastPage];
            } else if (currentPage === 4) {
                pages = [1, 2, 3, 4, 5, "...", lastPage - 1, lastPage];
            } else if (currentPage > lastPage - 4) {
                // Sửa ở đây: thêm số lastPage - 4 để hiển thị số thứ 50 (ví dụ) khi currentPage = 51
                pages = [1, 2, "...", lastPage - 4, lastPage - 3, lastPage - 2, lastPage - 1, lastPage];
            } else {
                pages = [
                    1,
                    2,
                    "...",
                    currentPage - 1,
                    currentPage,
                    currentPage + 1,
                    "...",
                    lastPage - 1,
                    lastPage,
                ];
            }
        }
        return pages.map((page, index) => (
            <button
                key={index}
                onClick={() => handlePageChange(page)}
                className={`mx-1 px-3 py-1 border rounded ${page === currentPage ? "bg-blue-500 text-white" : "bg-white text-blue-500"
                    }`}
            >
                {page}
            </button>
        ));
    };

    // Component phân trang dùng chung (đặt ở trên và dưới)
    const Pagination = () => (
        <div className="flex flex-wrap justify-center items-center my-2">
            <button
                onClick={() =>
                    switch_router(
                        `/reactapp/visual/home`
                    )
                }
                className="mx-1 px-3 py-1 border rounded"
            >
                Home
            </button>
            <button
                onClick={() => handlePageChange(currentPage - 1)}
                className="mx-1 px-3 py-1 border rounded"
            >
                Trước
            </button>
            {renderPaginationNumbers()}
            <button
                onClick={() => handlePageChange(currentPage + 1)}
                className="mx-1 px-3 py-1 border rounded"
            >
                Sau
            </button>
            <button
                onClick={() =>
                    switch_router(
                        `/reactapp/visual/category_test/${slug_2}?webappmode=showadview&page=${moviesData.page.last_page}`
                    )
                }
                className="mx-1 px-3 py-1 border rounded"
            >
                Trang cuối
            </button>
        </div>
    );

    return (
        <div className="container mx-auto p-2">
            {!moviesData ? (
                <div className="text-center py-4">Đang tải dữ liệu...</div>
            ) : (
                <>
                    {/* Phân trang ở trên */}
                    <Pagination />
                    <>
                        {
                            myCookieValue ?
                                (<>
                                    <h1 className="text-2xl font-bold mb-3 text-center">Danh sách phim</h1>
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                                        {moviesData.movies.map((movie) => (
                                            <div
                                                key={movie.id}
                                                className="bg-white rounded-lg shadow-md relative overflow-hidden p-2"
                                            >
                                                <img
                                                    src={movie.thumb_url}
                                                    alt={movie.name}
                                                    className="w-full object-cover"
                                                />
                                                <div className="p-2">
                                                    <h2 className="text-base font-semibold mt-1">{movie.name}</h2>
                                                    <p className="text-gray-500 text-sm">
                                                        {movie.time} - {movie.quality}
                                                    </p>
                                                    <Link
                                                        style={{ textDecoration: "none" }}
                                                        to={`/reactapp/visual/${movie.slug}?webappmode=showadview`}
                                                        className="mt-1 bg-blue-500 text-white px-2 py-1 rounded block text-center text-sm"
                                                    >
                                                        Xem ngay
                                                    </Link>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </>) :
                                (<>
                                    <Post_content mode={'telegram'} show_adsense={'YES'} channel={'freefltiktok'} id_post={'29'} />
                                </>)
                        }
                    </>
                    {/* Phân trang ở dưới */}
                    <Pagination />
                </>
            )}
        </div>
    );
};

export default MovieList;
